module.exports = __webpack_public_path__ + "static/404-7cf0d051254baad45b326ec0e5b8090d.png";